<div class="modal-content">
  <div class="modal-header">
    <h2 class="modal-title fw-bold">{{ 'createOrganisation.title' | translate }}</h2>
    <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
  </div>

  <div class="modal-body">
    <form>
      <!-- Company Type Selection -->
      <div class="type-selection-section">
        <div class="section-label">{{ 'createOrganisation.typeQuestion' | translate }} <span class="text-danger">*</span></div>
        <div class="type-cards" [class.is-invalid]="isCompanyTypeInvalid">
          @for (type of companyTypes; track type.value) {
            <div
              class="type-card"
              [class.selected]="companyType === type.value"
              [class.invalid-selection]="isCompanyTypeInvalid"
              (click)="companyType = type.value; onCompanyTypeChange()"
            >
              <div class="type-icon">
                <i class="fa {{ type.icon }}"></i>
              </div>
              <div class="type-name">{{ type.name }}</div>
              <div class="type-description">{{ type.description }}</div>
            </div>
          }
        </div>
      </div>

      <!-- Category Selection (for stores_services type) -->
      @if (companyType === 'stores_services') {
        <!-- Registration Fee Notice -->
        <div class="alert alert-info mb-4">
          <div class="d-flex align-items-center">
            <i class="fa fa-info-circle fs-4 me-3"></i>
            <div>
              <strong>{{ 'createOrganisation.registrationFee' | translate }}</strong>
              <p class="mb-0 small">{{ 'createOrganisation.registrationFeeDescription' | translate:{ amount: STORE_REGISTRATION_FEE } }}</p>
            </div>
          </div>
        </div>

        <div class="mb-5">
          <div class="section-label mb-2">{{ 'createOrganisation.categoryLabel' | translate }} <span class="text-danger">*</span></div>
          @if (loadingCategories) {
            <div class="text-center py-3">
              <div class="spinner-border spinner-border-sm text-primary" role="status">
                <span class="visually-hidden">{{ 'common.loading' | translate }}</span>
              </div>
            </div>
          } @else {
            <div class="form-floating">
              <select
                class="form-select"
                id="category"
                [(ngModel)]="categoryId"
                [ngModelOptions]="{standalone: true}"
                [class.is-invalid]="isCategoryInvalid"
              >
                <option [ngValue]="null" disabled>{{ 'createOrganisation.selectCategory' | translate }}</option>
                @for (cat of categories; track cat.category_id) {
                  <option [ngValue]="cat.category_id">
                    {{ cat.name }}
                  </option>
                }
              </select>
              <label for="category">{{ 'createOrganisation.categoryLabel' | translate }} *</label>
            </div>
          }
        </div>
      }

      <!-- Company Name -->
      <div class="mb-5">
        <app-input-component
          [type]="'text'"
          [label]="('createOrganisation.companyName' | translate) + ' *'"
          [(value)]="companyName"
          [placeholder]="('createOrganisation.companyName' | translate) + ' *'"
          [floating]="true"
          [invalid]="isCompanyNameInvalid"
        />
      </div>

      <!-- Organisation Number -->
      <div class="mb-5">
        <app-input-component
          [type]="'text'"
          [label]="'createOrganisation.organisationNumber' | translate"
          [(value)]="organisationNumber"
          [placeholder]="'createOrganisation.organisationNumber' | translate"
          [floating]="true"
        />
      </div>

      <!-- Email -->
      <div class="mb-5">
        <app-input-component
          [type]="'email'"
          [label]="('createOrganisation.email' | translate) + ' *'"
          [(value)]="email"
          [placeholder]="('createOrganisation.email' | translate) + ' *'"
          [floating]="true"
          [invalid]="isEmailInvalid"
        />
      </div>

      <!-- Phone -->
      <div class="mb-5">
        <app-input-component
          [type]="'text'"
          [label]="('createOrganisation.phone' | translate) + ' *'"
          [(value)]="phone"
          [placeholder]="('createOrganisation.phone' | translate) + ' *'"
          [floating]="true"
          [invalid]="isPhoneInvalid"
        />
      </div>

      <!-- Address -->
      <div class="mb-5">
        <app-input-component
          [type]="'text'"
          [label]="('createOrganisation.address' | translate) + ' *'"
          [(value)]="address"
          [placeholder]="('createOrganisation.address' | translate) + ' *'"
          [floating]="true"
          [invalid]="isAddressInvalid"
        />
      </div>

      <!-- City and Postal Code -->
      <div class="row mb-5">
        <div class="col-md-8">
          <app-input-component
            [type]="'text'"
            [label]="('createOrganisation.city' | translate) + ' *'"
            [(value)]="city"
            [placeholder]="('createOrganisation.city' | translate) + ' *'"
            [floating]="true"
            [invalid]="isCityInvalid"
          />
        </div>
        <div class="col-md-4">
          <app-input-component
            [type]="'text'"
            [label]="('createOrganisation.postalCode' | translate) + ' *'"
            [(value)]="postalCode"
            [placeholder]="('createOrganisation.postalCode' | translate) + ' *'"
            [floating]="true"
            [invalid]="isPostalCodeInvalid"
          />
        </div>
      </div>

      <!-- Country -->
      <div class="mb-5">
        <app-selectorini
          [options]="countries"
          [displayKey]="'name'"
          [valueKey]="'country_id'"
          [(value)]="countryId"
          [label]="('createOrganisation.country' | translate) + ' *'"
          [placeholder]="'createOrganisation.countryPlaceholder' | translate"
          [searchable]="true"
          [invalid]="isCountryInvalid"
        />
      </div>

      <!-- Description -->
      <div class="mb-5">
        <div class="form-floating">
          <textarea
            class="form-control"
            id="description"
            rows="4"
            [(ngModel)]="description"
            [ngModelOptions]="{standalone: true}"
            [placeholder]="'createOrganisation.description' | translate"
            style="height: 100px"
          ></textarea>
          <label for="description">{{ 'createOrganisation.description' | translate }}</label>
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <app-button
      [variant]="'neutral'"
      [label]="'createOrganisation.cancel' | translate"
      (clicked)="close()"
    />
    @if (companyType === 'stores_services') {
      <app-button
        [variant]="'primary'"
        [label]="loading ? ('createOrganisation.redirecting' | translate) : ('createOrganisation.payAndCreate' | translate:{ amount: STORE_REGISTRATION_FEE })"
        [iconClass]="loading ? 'fa fa-spinner fa-spin' : 'fa fa-credit-card'"
        [disabled]="loading"
        (clicked)="createOrganisation()"
      />
    } @else {
      <app-button
        [variant]="'primary'"
        [label]="loading ? ('createOrganisation.creating' | translate) : ('createOrganisation.create' | translate)"
        [iconClass]="loading ? 'fa fa-spinner fa-spin' : 'fa fa-plus'"
        [disabled]="loading"
        (clicked)="createOrganisation()"
      />
    }
  </div>
</div>
